export const CONSTRUCTIVE_FEEDBACK_QUESTION =
  'How do you feel about constructive feedback?'

export const CONSTRUCTIVE_FEEDBACK_OPTIONS = [
  { key: 'chanceToGrow', i18nKey: 'chanceToGrow' },
  { key: 'hurtsALittle', i18nKey: 'hurtsALittle' },
  { key: 'dependsOnWhoSaysIt', i18nKey: 'dependsOnWhoSaysIt' },
] as const

export type TConstructiveFeedbackAnswerKey =
  typeof CONSTRUCTIVE_FEEDBACK_OPTIONS[number]['key']

export const CONSTRUCTIVE_FEEDBACK_FEEDBACK: Record<
  TConstructiveFeedbackAnswerKey,
  { badge: string; text: string }
> = {
  chanceToGrow: {
    badge:
      'onboarding.communicationConstructiveFeedback.feedback.chanceToGrow.badge',
    text: 'onboarding.communicationConstructiveFeedback.feedback.chanceToGrow.text',
  },
  hurtsALittle: {
    badge:
      'onboarding.communicationConstructiveFeedback.feedback.hurtsALittle.badge',
    text: 'onboarding.communicationConstructiveFeedback.feedback.hurtsALittle.text',
  },
  dependsOnWhoSaysIt: {
    badge:
      'onboarding.communicationConstructiveFeedback.feedback.dependsOnWhoSaysIt.badge',
    text: 'onboarding.communicationConstructiveFeedback.feedback.dependsOnWhoSaysIt.text',
  },
}
